if (!customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.read-more__content');
      this.toggle = this.querySelector('.read-more__toggle');
      this.resizeObserver = null;
      this.isExpanded = false;
    }

    connectedCallback() {
      if (!this.content || !this.toggle) return;

      this.init();
      
      this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
      this.resizeObserver.observe(this.content);
      this.toggle.addEventListener('click', () => this.toggleContent());
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    init() {
      this.checkOverflow();
    }

    toggleContent() {
      this.isExpanded = !this.isExpanded;
      this.setAttribute('data-expanded', this.isExpanded);
      this.checkOverflow();
    }

    checkOverflow() {
      if (!this.content || !this.toggle) return;

      if (this.isExpanded) {
        this.toggle.style.display = 'inline-flex';
        return;
      }
      const isOverflowing = this.content.scrollHeight > this.content.clientHeight + 1;
      
      this.toggle.style.display = isOverflowing ? 'inline-flex' : 'none';
      this.setAttribute('data-overflowing', isOverflowing);
    }
  }

  customElements.define('read-more', ReadMore);
}
